import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from '../../../utils/url';
import axios from '../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapEthnicity from '../../../components/OrganizationSetup/MapEthnicity/MapEthnicity';
import EnterpriseBreadcrumb from '../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapEthnicityManagement extends Component {
  // constructor(props) {
  //   super(props);
  // }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    console.log("did mount management")
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      console.log(payload)
      const {ethnicity} = payload.mapping;
      if(ethnicity.columnName) {
        this.props.onMatchColumn(ethnicity.columnName);
      }
      const ethnicityData = ethnicity.data;
      let allMapping = []
      ethnicityData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllEthnicityMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapEthnicityStep();
  }

  handleFileUpload = (columns, data, file) => {
    console.log(columns, data, file)
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip performance mapping');
  }

  render() {
    console.log(this.props)
    return (
      <div className="mt60">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Ethnicity/Race"
        {...this.props}
        />
      <MapEthnicity 
        onProcessedFileUploadData={this.handleFileUpload}
        onSkipEthnicityMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log(state)
  return {
    user: state.user.profile,
    mapEthnicity : state.mapping.ethnicity
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapEthnicityStep: () => dispatch(actionCreators.resetMapEthnicityStep()),
    nextStep: () => dispatch(actionCreators.mapEthnicityNextStep()),
    goBack : () => dispatch(actionCreators.mapEthnicityGoBack()),
    reset : () => dispatch(actionCreators.resetEthnicity()),
    saveAllEthnicityMapping : (o,s) => dispatch(actionCreators.saveAllEthnicityMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapEthnicityUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapEthnicityMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapEthnicityManagement);